<div class="reply-container" *ngIf="luss.isLogged">
    <div class="reply-input-wrapper">
      <div class="reply-avatar">
        <unh-user-avatar
          [avatarUrl]="userAvatarUrl"
          [username]="luss.user.alias"
          [uid]="luss.user.uid+''"
          [userSubscribed]="luss.subscribed"
          [hasUnreadNotifs]="false"
          [redirectToProfile]="true"
          [defaultAvatarUrl]="defaultAvatarUrl"
        ></unh-user-avatar>
      </div>

      <div class="reply-wrapper" >
        <!-- <quill-editor
        #quillInstance
        [modules]="QuillModules"
        [placeholder]="'Comece a digitar aqui...'"
        [maxLength]="1000"
        [trimOnValidation]="true"
        (onEditorChanged)="onReplyEditorChanged($event)"
        ></quill-editor> -->
      <unh-comment-quill-editor
      [readonly]="false"
      (onImagesChanged)="onImagesChanged($event)"
      (onEditorCreated)="null"
      (onEditorChanged)="onReplyEditorChanged($event)"
      ></unh-comment-quill-editor>

      </div>
    </div>

  <!-- <textarea
    #textArea
    class="input-reply"
    matInput
    cdkTextareaAutosize
    cdkAutosizeMinRows="1"
    cdkAutosizeMaxRows="5"
  ></textarea> -->
  <div class="reply-actions">
    <a
        mat-button
        theme="white-pink-outline"
        class="unh-button-old cancel"
        (click)="closeReply()"
    >
        Cancelar
    </a>
    <a
      mat-button
      theme="pink-white"
      class="unh-button-old submit"
      [disabled]="submitDisabled"
      (click)="!submitDisabled? submitReply(): null"

    >
      Publicar
    </a>
</div>

  <div class="btn-container">
    <button
      class="transparent"
      mat-fab
      aria-label="buttonType.arialabel"
      (click)="submitReply()"
      [disabled]="replyText?.length < 1"
    >
      <mat-icon>send</mat-icon>
    </button>
  </div>
</div>
